// Les audits : la liste (lancer, suivre, comparer) et la restitution.
export default {
  liste: {
    sousTitre: 'Audits datés et comparables',
    intro: 'Chaque audit fige un état daté et comparable de la marque.',
    analyseSeule: 'Analyse seule',
    analyseSeuleTitre: 'Analyse seule : ré-analyse la marque sur les données déjà collectées, sans nouvelle collecte ni nouvelle mesure de la présence IA - rapide',
    whiteSpacesTitre: 'Détecte le white space maintenant, sur les signaux déjà en base, sans relancer d’analyse complète. Remplace le white space auto-détecté précédent.',
    cascadeTitre: 'Inclure aussi les marques enfants de la hiérarchie. Décoché : la marque sélectionnée uniquement.',
    recalculerTitre: 'Recalcule le Brand Strength (4R) du focal + descendants sur les signaux déjà en base, y compris la moyenne cluster (moyenne des concurrents par dimension). Sans nouvelle collecte.',
    recalculer: 'Recalculer 4R',
    resyncTitre: 'Migration : supprime les anciens systèmes solaires saisis à la main, ré-attache les planètes directement à la galaxie et redétecte les territoires. Irréversible.',
    resync: 'Resync territoires',
    dejaEnCours: 'Un audit est déjà en cours pour cette marque',
    profondTitre: 'Audit profond : nouvelle collecte (comptes officiels + concurrents), puis analyse complète. Si les données sont récentes, la collecte est sautée automatiquement. Il mesure aussi la présence IA (ce que les assistants répondent sur la marque), de l’ordre d’un dollar.',
    enCoursBouton: 'Audit en cours…',
    lancerProfond: 'Lancer un audit profond',
    lectureSeule: 'Votre rôle ({role}) est en lecture seule sur cet écran - lancer un audit demande le rôle {analyst}. Demandez l\'élévation à un administrateur de votre organisation.',
    roleInconnu: 'inconnu',
    collecteEnCours: 'Collecte en cours · {n} source | Collecte en cours · {n} source | Collecte en cours · {n} sources',
    suppressionImpossible: 'Suppression impossible',
    lancementImpossible: 'Lancement impossible',
    detectionImpossible: 'Détection impossible',
    resyncImpossible: 'Resync impossible',
    recalculImpossible: 'Recalcul impossible',
    confirmerSuppression: 'Supprimer cet audit ({profondeur}, {date}) ?\n\nLe snapshot produit et les données d\'analyse sont conservés - seul l\'enregistrement du run est retiré. Action irréversible.',
    wsDetectes: '{n} white space(s) détecté(s) : {liste}',
    wsItem: '« {label} » ({score}) - {nom}',
    aucunWs: 'Aucun white space détecté.',
    wsEchecs: 'Échecs : {liste}',
    confirmerResync: 'Resynchroniser les territoires de cette galaxie ?\n\n• supprime les systèmes solaires saisis à la main\n• ré-attache les planètes directement à la galaxie\n• redétecte les territoires (galaxie + planètes)\n\nAction irréversible.',
    resyncFait: 'Resync effectué : {planetes} planète(s) ré-attachée(s) · {systemes} système(s) solaire(s) supprimé(s) · {territoires} territoire(s) rattaché(s).',
    recalcule: 'Brand Strength (4R) recalculé - la moyenne cluster suit désormais la moyenne des concurrents par dimension.',
    etapes: {
      rescue_similarity: 'Rescue des exclusions',
      sentiment: 'Scoring de sentiment',
      official_accounts: 'Ingestion des comptes officiels',
      cluster_estimate: 'Concurrents externes',
      personas: 'Personas',
      territoires: 'Territoires de la marque',
      brand_strength: 'Brand Strength Score',
      white_spaces: 'Détection des espaces blancs',
      calendar: 'Calendrier culturel',
      presence_llm: 'Présence IA',
    },
    statuts: {
      pending: 'en attente',
      running: 'en cours',
      done: 'terminé',
      error: 'erreur',
    },
    declencheurs: {
      manual: 'manuel',
      wizard: 'wizard',
      autopilot: 'autopilote',
      scheduler: 'planifié',
    },
    profondeurs: {
      leger: 'leger',
      profond: 'profond',
    },
    colProfondeur: 'Profondeur',
    colStatut: 'Statut',
    colLance: 'Lancé le',
    colDuree: 'Durée',
    sansResultat: 'sans résultat : {liste}',
    restitutionTitre: 'Ouvre la restitution de CET audit - présentation scrollable, prête à partager en réunion',
    restitution: 'Restitution',
    tourneEncore: 'Cet audit tourne encore - attendez sa fin pour le retirer.',
    supprimerTitre: 'Supprimer cet audit (le snapshot produit et les données d’analyse restent). Irréversible.',
    colMarque: 'Marque',
    colDeclencheur: 'Déclencheur',
    colSignaux: 'Signaux',
    colDelta: 'Delta score',
    colDate: 'Date',
    chargement: 'Chargement…',
    aucunSnapshot: 'Aucun snapshot - lancez une analyse complète depuis Brand V3 pour créer le premier audit.',
    comparaison: 'Comparaison · {marque} - dernier snapshot vs précédent',
    scorePrecedent: 'Score de marque · précédent',
    scoreDate: 'Score de marque · {date}',
    baisse: 'La baisse de {dim} ({delta}) est le signal négatif le plus fort - deep-dive recommandé.',
    ouvrir: 'Ouvrir →',
  },
  rapport: {
    aujourdhui: 'aujourd\'hui',
    dansJours: 'dans {n} j',
    dansMois: 'dans {n} mois',
    hubIndice: '{mentions} mentions · {auteurs} auteurs distincts',
    provenanceCetAudit: 'Mesurée pendant cet audit, le {date}.',
    provenanceLeger: 'Mesure du {date}, la dernière avant cet audit : un audit léger ne la refait pas.',
    provenanceAvant: 'Mesure du {date}, la dernière avant cet audit.',
    provenanceDerniere: 'Dernière mesure, le {date}.',
    et: '{debut} et {fin}',
    introSalut: 'Salut, moi c\'est {nom}.',
    introAge: 'J\'ai entre {tranche} ans.',
    introAgeEt: ' et ',
    introReste: 'Ce qui me fait rester ? {jtbd}',
    introPartir: 'Ce qui me ferait partir ? {tension}',
    transition: 'Et là, c\'est {nom} - {suite}. →',
    aPeineArrive: 'à peine arrivé·e, à valider',
    transitionFin: 'Vous les connaissez. Maintenant, parlez-leur. ↓',
    concurrent: 'Concurrent',
    decisionDefaut: 'Investir le territoire « {label} » - l\'espace est libre, le signal est mesuré.',
    signauxConstruits: 'construits depuis votre audience',
    preparation: 'Préparation de la restitution…',
    basculerTheme: 'Basculer dark / light',
    ouvrirOrion: 'Ouvrir dans Orion →',
    restitutionAudit: 'Restitution d\'audit',
    bssInfo: 'Moyenne pondérée 4R, fenêtre 90 j glissants, normalisée sur le cluster de référence',
    depuisLe: 'depuis le {date}',
    analyseComplete: 'analyse complète',
    lesPersonas: 'Les personas',
    personnesRegardent: '{n} personne regarde votre marque. | {n} personne regarde votre marque. | {n} personnes regardent votre marque.',
    portraitEnCours: 'portrait en cours de génération…',
    aValider: 'à valider',
    partAudience: 'part d\'audience',
    confiance: 'confiance',
    quatreSignaux: 'Les quatre signaux',
    titreSignaux: 'Quatre signaux.',
    titreSignauxLimitant: 'Quatre signaux. Un facteur limitant.',
    tiennent: '{liste} tient le cluster - {limitant} borne le score. | {liste} tient le cluster - {limitant} borne le score. | {liste} tiennent le cluster - {limitant} borne le score.',
    autresSignaux: 'Les autres signaux',
    compareCluster: 'Chaque signal est comparé au cluster de référence.',
    facteurLimitant: 'facteur limitant',
    levier: '{dim} est à {v} contre {avg} pour le cluster - le levier prioritaire du prochain cycle.',
    methodoTitre: 'Scores normalisés 0-100 contre le cluster de référence - méthodo dans le deep-dive',
    aucunScore: 'Aucun score calculé - lancez un audit complet.',
    presenceIA: 'La présence IA',
    presenceTitre: '{n}/100 dans les assistants.',
    presenceTitreSans: 'Ce que les assistants savent de vous.',
    presenceSous: 'Ce que {assistants} répondent quand on leur demande conseil dans votre catégorie, sans vous nommer. {provenance}',
    lesAssistants: 'les assistants',
    muetTitre: 'Aucune réponse (clé ou crédits) : ce n’est pas « ne cite pas »',
    indisponible: 'indisponible',
    citeeSpontanement: 'citée spontanément : {pct} %',
    echecCetAudit: 'La mesure de cet audit n\'a pas abouti ({raison}).',
    echecPrecedente: 'La mesure de cet audit n\'a pas abouti ({raison}) : c’est la précédente qui est montrée.',
    pasMesuree: 'La présence IA n\'a pas pu être mesurée.',
    raison: 'Raison : {raison}. Son échec n\'a pas arrêté l\'audit, et elle se remesurera au prochain audit profond.',
    voirReponses: 'Voir chaque réponse →',
    carrefours: 'Les carrefours d\'audience',
    audienceDit: 'Ce que votre audience dit.',
    lesTerritoires: 'Les territoires',
    vitSur: '{marque} vit sur {n} territoire. | {marque} vit sur {n} territoire. | {marque} vit sur {n} territoires.',
    segments: 'Les segments de marché détectés sur vos signaux - c\'est sur leurs études sectorielles que le panel d\'étude s\'ancre.',
    deLaMarque: 'de la marque',
    detectesAudit: 'détectés à l\'audit · mutualisés entre marques · adossés aux études publiques du secteur',
    territoire: 'Territoire',
    espaceLibreL1: 'Un espace',
    espaceLibreL2: 'est libre.',
    cielL1: 'Votre ciel',
    cielL2: 'd\'audience.',
    clusterEmerge: 'Le cluster « {label} » émerge - et personne n\'est installé dessus.',
    recouvrement: 'Recouvrement maximal : {pct} % ({nom}).',
    sansWs: 'Votre marque et les recouvrements d\'audience avec son cluster. Aucun white space détecté pour l\'instant - il apparaîtra ici dès que les signaux le révèlent - dès que votre audience est suffisante, relancez une analyse.',
    clusterEmergent: 'cluster émergent · à valider',
    carteComplete: 'carte complète →',
    espaceLibre: 'Espace libre',
    leCalendrier: 'Le calendrier',
    aNePasManquer: 'À ne pas manquer.',
    ouvrirCalendrier: 'Ouvrir le calendrier du dossier →',
    laDecision: 'La décision',
    genererPourDecision: 'Générez le brief pour transformer ces signaux en décision d\'action.',
    ouvrirBrief: 'Ouvrir le brief',
    genererBrief: 'Générer le brief',
    lancerBlast: 'Lancer le BLAST',
    generee: 'Orion · restitution générée le {date}',
  },
}
